import { hasValue } from "../../../../utils/functions";
import dateField from "../../../common/date-field";
import calendar from "../../../common/date-field";

export default {
  name: "providers",
  components: {
    calendar,
    dateField,
  },
  data: function () {
    return {
      dateRange: {
        from: null,
        to: null,
      },
      IsAccountsPayable: false,
      loadingList: false,
      loadingModal: false,
      loadingCNPJ: false,
      loadingCEP: false,
      lastSearchedZipCode: null,
      loadingPaymentProviderInternalType: false,
      loadingProviderType: false,
      loadingBankList: false,
      isSeeing: false,
      isCreating: false,
      validatedFormValidation: false,
      countFilter: 0,
      labelName: "Nome",
      labelIdentity: "CNPJ",
      labelOccupation: "Email",
      modalTitle: "Novo Fornecedor",
      providers: [],
      providerTypes: [],
      paymentProviderInternalTypes: [],
      banks: [],
      providerRoot: [],
      providerProfiles: [],
      cities: [],
      providerFiles: [],
      listNamesFile: [],
      countries: [],
      states: [],
      statesFilter: [],
      citiesFilter: [],
      countriesFilter: [],
      usersRoot: [],
      providerAccountTypes: [
        { "Code": 1, "Name": "Conta Corrente" },
        { "Code": 2, "Name": "Conta Poupança" }
      ],
      mCurrentStep: 0,
      mSteps: ["Dados Básicos", "Endereço", "Pagamento", "Contato", "Aprovação"],
      typePayment: {
        pix: false,
        TED: false,
        ticket: false
      },
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      filter: {
        Name: null,
        Identity: null,
        ContractStartDate: null,
        ContractEndDate: null,
        ContractStartDateFrom: null,
        ContractEndDateFrom: null,
        IdUserInternal: null,
        StatusProvider: null,
        Situation: 0,
        ProviderType: {
          Id: 0,
        },
        Address: {
          City: {
            Name: null,
          },
          State: {
            Initials: null,
          },
          Country: {
            Name: null,
          },
        },
        PaymentMethodProviderInternal: {
          PaymentProviderInternalType: { Id: null },

        },
        Contact: {
          Name: null,
        },
      },
      idProvider: 0,
      infoUserInternal: {
        Name: null,
        Identity: null,
        IdUserInternal: null,
        Email: null,
        Phone: null,
        Occupation: null,
        UserInternalRoot: {
          Id: 0,
        },
        UserProfileInternal: {
          Code: null,
        },
      },
      MAX_LENGTH_Observation: 200,
      infoProviderInternal: {
        Observation: null,
        Site: null,
        CompanyName: null,
        Url: null,
        FileName: null,
        Identity: null,
        SimpleNational: false,
        StatusProvider: null,
        Situation: 1,
        ValidatePLD: false,
        CreatedDate: new Date(),
        FileProviderInternal: [],
        HasContract: false,
        HasConfidentialityAgreement: false,
        ContractStartDate: null,
        ContractEndDate: null,
        ProviderFile: {
          File: []
        },
        PaymentMethodProviderInternal: {
          PaymentProviderInternalType: { Id: null },
          PaymentProviderInternalBank: {
            Name: null,
            Account: null,
            Agency: null,
            DigitAccount: null,
            DigitAgency: null
          },
          PaymentProviderInternalPix: {
            KeyName: null,
            Key: null
          }
        },
        Contact: {
          Name: null,
          DDD: null,
          Phone: null,
          Email: null
        },
        ProviderType: {
          Id: 0,
          Description: null
        },
        Address: {
          Street: null,
          District: null,
          Number: null,
          ZipCode: null,
          Complement: null,
          City: {
            Name: null,
            CityCodeIBGE: null
          },
          State: {
            Initials: null,
          },
          Country: {
            Name: null,
          },
        },
      },
    };
  },
  computed: {
    Country() {
      return this.infoProviderInternal.Address.Country.Name;
    },
    State() {
      return this.infoProviderInternal.Address.State.Initials;
    },
    FilterCountry() {
      return this.filter.Address.Country.Name;
    },
    FilterState() {
      return this.filter.Address.State.Initials;
    },
    isDateRequired() {
      return this.infoProviderInternal.HasContract
    },
    isDateStart() {
      return this.infoProviderInternal.ContractStartDate
    },
    isLoading() {
      return this.loadingList || this.loadingModal || this.loadingPaymentProviderInternalType || this.loadingProviderType;
    }
  },
  watch: {
    "pagination.PageNumber": function () {
      this.ListProvider();
    },
    State(selected, old) {
      // Update City list when the State (of Country) is changed.
      if (selected != null) {
        this.$store
          .dispatch("ListCity", { stateInitials: selected })
          .then((response) => {
            if (selected == "EX") {
              const state = this.states.find(elem => elem.Initials == selected);
              this.cities = [response.find(elem => elem.IdState == state.Id)];
            } else {
              this.cities = response;
            }
          });
        if (selected != old && old != undefined && !this.isSearchZipCode) {
          this.infoProviderInternal.Address.City.Name = null;
        }
      } else {
        this.cities = [];
        this.infoProviderInternal.Address.City.Name = null;
      }
      if (this.isSearchZipCode) this.isSearchZipCode = false;
    },
    Country(selected, old) {
      // Update State list when the Country is changed.
      if (selected != null) {
        this.ListState(selected);
        if (selected != old && old != undefined && !this.isSearchZipCode) {
          this.infoProviderInternal.Address.State.Initials = null;
        }
      } else {
        this.states = [];
        this.infoProviderInternal.Address.State.Initials = null;
      }
      if (this.isSearchZipCode) this.isSearchZipCode = false;
    },
    FilterState(selected, old) {
      // Update City list when the State (of Country) is changed.
      if (selected != null) {
        this.$store
          .dispatch("ListCity", { stateInitials: selected })
          .then((response) => {
            if (selected == "EX") {
              const state = this.statesFilter.find(elem => elem.Initials == selected);
              this.citiesFilter = [response.find(elem => elem.IdState == state.Id)];
            } else {
              this.citiesFilter = response;
            }
          });
        if (selected != old && old != undefined && !this.isSearchZipCode) {
          this.filter.Address.City.Name = null;
        }
      } else {
        this.citiesFilter = [];
        this.filter.Address.City.Name = null;
      }
      if (this.isSearchZipCode) this.isSearchZipCode = false;
    },
    FilterCountry(selected, old) {
      // Update State list when the Country is changed.
      if (selected != null) {
        this.ListStateFilter(selected);
        if (selected != old && old != undefined && !this.isSearchZipCode) {
          this.filter.Address.State.Initials = null;
        }
      } else {
        this.statesFilter = [];
        this.filter.Address.State.Initials = null;
      }
      if (this.isSearchZipCode) this.isSearchZipCode = false;
    },
    "infoProviderInternal.Identity": function (val) {
      if (!this.isCreating || !val) return;
      const digits = val.replace(/\D/g, "");
      if (digits.length === 14) {
        this.loadingCNPJ = true;
        this.$store
          .dispatch("GetProviderByNameIdentity", { name: "", identity: digits })
          .then((response) => {
            if (response && response.length > 0) {
              this.$makeToast(
                "Já existe um fornecedor cadastrado com este CNPJ.",
                "warning",
                "CNPJ já cadastrado"
              );
              this.loadingCNPJ = false;
            } else {
              this.SearchByCNPJ(digits);
            }
          })
          .catch(() => {
            this.SearchByCNPJ(digits);
          });
      }
    },
    "infoProviderInternal.Address.ZipCode": function (val) {
      if (this.isSeeing || !val) return;
      const digits = val.replace(/\D/g, "");
      if (digits.length === 8 && digits !== this.lastSearchedZipCode) {
        this.SearchByZipCode();
      }
    },

  },
  beforeMount() {
    let params = this.$route.query;
    if (params != null && params.IsAccountsPayable) {
      this.IsAccountsPayable = params.IsAccountsPayable
    }
  },
  mounted() {
    this.ListProvider();
    this.ListPaymentProviderInternalType();
    this.ListProviderType();
    this.ListCountry();
    this.ListUserInternalRoot();
    this.ListBanks();
    if (this.IsAccountsPayable) {
      this.OpenNewProvider();
      this.$router.replace({ 'query': null });
    }
  },
  methods: {
    onChange: function (e) {
      this.typePayment = {
        pix: false,
        TED: false,
        ticket: false
      }
      switch (e) {
        case 1: this.typePayment.pix = true; break;
        case 2: this.typePayment.TED = true; break;
        case 3: this.typePayment.ticket = true; break;
        default: this.typePayment.ticket = true; break;
      }
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },

    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListProvider();
    },
    Download(url) {
      if (url != null && url.length > 5) window.open(url, "_blank");
      else {
        this.$makeToast("O link do arquivo é inválido.", "danger", "Erro no download");
      }
    },
    ListPaymentProviderInternalType: function () {
      this.countFilter = 0;
      this.loadingPaymentProviderInternalType = true;

      this.$store
        .dispatch("ListPaymentProviderInternalType")
        .then((response) => {
          this.paymentProviderInternalTypes = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "warning",
            "Erro ao listar os provider type",
            error
          );
        })
        .finally(() => {
          this.loadingPaymentProviderInternalType = false;
        });
    },
    ListProviderType: function () {
      this.countFilter = 0;
      this.loadingProviderType = true;

      this.$store
        .dispatch("ListProviderTypeInternal")
        .then((response) => {
          this.providerTypes = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "warning",
            "Erro ao listar os provider type",
            error
          );
        })
        .finally(() => {
          this.loadingProviderType = false;
        });
    },

    ListBanks: function () {
      this.countFilter = 0;
      this.loadingBankList = true;
      let dataBanks = {
        "Object.Name": null,
        "Object.Code": null,
        "Object.ISPB": null
      };
      this.$store
        .dispatch("BankList", { params: dataBanks })
        .then(response => {
          this.banks = response.Objects;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao listar os Bancos", error);
        })
        .finally(() => (this.loadingBankList = false));
    },

    ResetFilter: function () {
      this.filter = {
        Name: null,
        Identity: null,
        ContractStartDate: null,
        ContractEndDate: null,
        ContractStartDateFrom: null,
        ContractEndDateFrom: null,
        IdUserInternal: null,
        StatusProvider: null,
        Situation: 0,
        ProviderType: {
          Id: 0,
        },
        Address: {
          City: {
            Name: null,
          },
          State: {
            Initials: null,
          },
          Country: {
            Name: null,
          },
        },
        PaymentMethodProviderInternal: {
          PaymentProviderInternalType: { Id: null },
          PaymentProviderInternalBank: {
            Name: null,
            Account: null,
            Agency: null,
            DigitAccount: null,
            DigitAgency: null
          },
          PaymentProviderInternalPix: {
            KeyName: null,
            Key: null
          }
        },
        Contact: {
          Name: null,
        },
      }

      this.ListProvider();
    },

    SearchByCNPJ: function (identity) {
      this.loadingCNPJ = true;
      this.$store
        .dispatch("QueryProviderCNPJ", identity)
        .then((response) => {
          if (!response || response.status === "ERROR") return;
          if (response.razaoSocial) this.infoProviderInternal.CompanyName = response.razaoSocial;
          if (response.nomeFantasia) this.infoProviderInternal.Name = response.nomeFantasia;
          if (response.logradouro) this.infoProviderInternal.Address.Street = response.logradouro;
          if (response.numero) this.infoProviderInternal.Address.Number = response.numero;
          if (response.complemento) this.infoProviderInternal.Address.Complement = response.complemento;
          if (response.bairro) this.infoProviderInternal.Address.District = response.bairro;
          if (response.cep) this.infoProviderInternal.Address.ZipCode = response.cep.replace(/\D/g, "");
          if (response.municipio) this.infoProviderInternal.Address.City.Name = response.municipio;
          if (response.uf) this.infoProviderInternal.Address.State.Initials = response.uf;
          this.infoProviderInternal.Address.Country.Name = "BRASIL";
          if (response.email) this.infoProviderInternal.Contact.Email = response.email;
          if (response.telefone) {
            const digits = response.telefone.replace(/\D/g, "");
            if (digits.length >= 10)
              this.infoProviderInternal.Contact.Phone = digits;
          }
        })
        .catch(() => {
          this.$makeToast("Não foi possível consultar o CNPJ.", "warning", "Consulta CNPJ");
        })
        .finally(() => {
          this.loadingCNPJ = false;
        });
    },
    SearchByZipCode: function () {
      if (this.isSeeing == false) {
        let zipCodeNumber = this.infoProviderInternal.Address.ZipCode.replace(/\D+/gm, "");

        if (zipCodeNumber.length != 8) {
          this.$makeToast(
            "O CEP digitado não é válido. " + zipCodeNumber,
            "danger",
            "CEP inválido"
          );
          return;
        }

        this.lastSearchedZipCode = zipCodeNumber;
        this.loadingCEP = true;
        this.$store
          .dispatch("ListCep", { zipCode: zipCodeNumber })
          .then((response) => {
            if (response.erro) {
              this.$makeToast(
                "Verifique o número digitado e tente novamente.",
                "warning",
                "CEP não encontrado"
              );
              return;
            }
            this.isSearchZipCode = true;

            this.infoProviderInternal.Address.ZipCode = response.cep;
            this.infoProviderInternal.Address.Street = response.logradouro;
            this.infoProviderInternal.Address.District = response.bairro;

            this.infoProviderInternal.Address.Country.Name = "BRASIL";
            this.infoProviderInternal.Address.State.Initials = response.uf;
            this.infoProviderInternal.Address.City.Name = response.localidade;
            this.infoProviderInternal.Address.City.CityCodeIBGE = response.ibge;
          })
          .catch((error) => {
            this.$makeToast(
              "Não foi possível buscar o endereço.",
              "danger",
              "Busca de endereço"
            );
          })
          .finally(() => {
            this.loadingCEP = false;
          });
      }
    },
    SelectedFile(obj, isEvent) {
      let files = [];
      if (isEvent) files = obj.target.files;
      else files = obj;
      if (files.length === 0 || typeof files.forEach != "function") return;

      let MAX_MAIL_SIZE = 10240; // 10MiB
      let totalSize = 0;
      let isValid = true;
      files.forEach((file) => {
        totalSize += Math.round(file.size / 1024);

        const ObjectFile = {
          Id: file.size / 1024,
          Name: file.name
        }

        this.$refs["file-input"].reset();
        if (file.type == "application/pdf") {
          this.providerFiles.push(file)
          this.infoProviderInternal.FileProviderInternal.push(ObjectFile);
        } else {
          this.$makeToast(
            "O arquivo selecionado não é um PDF válido",
            "danger",
            "Documento do cliente"
          );
        }
      });

      if (totalSize > MAX_MAIL_SIZE) {
        this.$makeToast(
          "Tamanho total dos arquivos excedeu 10MiB. Verifique o tamanho total.",
          "danger",
          "Limite total excedido"
        );
        return;
      }

      if (isValid)
        this.$refs["file-input"].reset();
    },

    AppendFormData(obj, form, namespace) {
      var fd = form || new FormData();
      var formKey;

      for (var property in obj) {
        if (obj.hasOwnProperty(property)) {
          if (namespace) {
            formKey = namespace + "[" + property + "]";
          } else {
            formKey = property;
          }

          // if the property is an object, but not a File,
          // use recursivity.
          if (typeof obj[property] === "object") {
            this.AppendFormData(obj[property], fd, formKey);
          } else {
            if (typeof obj[property] === "number") {
              fd.append(formKey, obj[property].toString().replace(".", ","));
            } else {
              fd.append(formKey, obj[property]);
            }
          }
        }
      }

      return fd;
    },
    GetFormData(object) {
      return this.AppendFormData(object);
    },
    GetProvider: function (id, seeing) {
      this.mCurrentStep = 0;
      this.loadingModal = true;
      this.isCreating = false;
      this.ResetInfoProvider();
      this.idUserInternal = id;
      this.$store
        .dispatch("GetProviderInternal", { id: id })
        .then((response) => {
          this.infoProviderInternal = response;
          if (this.infoProviderInternal.PaymentMethodProviderInternal.PaymentProviderInternalType.Id == 2) {
            this.AccountType = this.infoProviderInternal.PaymentMethodProviderInternal.PaymentProviderInternalBank.IdAccountType;
          }
          else if (this.infoProviderInternal.PaymentMethodProviderInternal.PaymentProviderInternalType.Id != 2) {
            this.AccountType = null;
            this.infoProviderInternal.PaymentMethodProviderInternal.PaymentProviderInternalBank = {
              Name: null,
              Account: null,
              Agency: null,
              DigitAccount: null,
              DigitAgency: null,
              IdAccountType: null
            }
          }
          if (this.infoProviderInternal.PaymentMethodProviderInternal.PaymentProviderInternalType.Id != 1) {
            this.AccountType = null;
            this.infoProviderInternal.PaymentMethodProviderInternal.PaymentProviderInternalPix = {
              KeyName: null,
              Key: null
            }
          }

          if (this.infoProviderInternal.StatusProvider == 0)
            this.infoProviderInternal.StatusProvider = null;
          if (typeof seeing != "undefined") {
            this.isSeeing = true;
            this.modalTitle = "Detalhes do Fornecedor";
          } else {
            this.isSeeing = false;
            this.modalTitle = "Editar Fornecedor";
          }

          this.ShowProvider();
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao carregar o fornecedor",
            error
          );
        })
        .finally(() => {
          this.loadingModal = false;
        });
    },
    RemoveProvider: function (id) {
      this.$store
        .dispatch("DeleteProviderInternal", id)
        .then(() => {
          this.$makeToast(
            "removido da sua lista de fornecedor.",
            "success",
            "Fornecedor removido"
          );
          this.FeedbackProvider();
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao remover o fornecedor",
            error
          );
        });
    },
    DeleteFileProviderInternal: function (id, name, Url) {
      this.loadingModal = true;
      if (Url == null) {
        const listFilesSalved = [];
        const listFileView = [];
        this.infoProviderInternal.FileProviderInternal.find(provider => { if (provider.Name !== name) listFilesSalved.push(provider) });
        this.providerFiles.find(provider => { if (provider.Url == null && provider.name !== name) listFileView.push(provider) });
        this.infoProviderInternal.FileProviderInternal = listFilesSalved;
        this.providerFiles = listFileView;
        this.loadingModal = false;
      } else {
        this.$store
          .dispatch("DeleteFileProviderInternal", id)
          .then(() => {
            this.$makeToast(
              "Anexo excluído com sucesso.",
              "success",
              "Anexo excluído"
            );
            for (let i = 0; i < this.infoProviderInternal.FileProviderInternal.length; i++) {
              if (this.infoProviderInternal.FileProviderInternal[i].Id == id) {
                this.infoProviderInternal.FileProviderInternal.splice(i, 1);
                break;
              }
            }
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao remover o anexo",
              error
            );
          }).finally(() => {
            this.loadingModal = false;
          });
      }
    },
    ShowProvider: function () {
      this.validatedFormValidation = false;
      this.$bvModal.show("mFormProvider");
    },
    OpenNewProvider: function () {
      this.mCurrentStep = 0;
      this.ResetInfoProvider();
      this.isCreating = true;
      this.isSeeing = false;
      this.modalTitle = "Novo Fornecedor";
      this.ShowProvider();
      this.ListProviderType();
      this.ListPaymentProviderInternalType()

    },
    ResetInfoProvider: function () {
      this.idProvider = 0,
        this.providerFiles = [],
        this.infoProviderInternal = {
          Observation: null,
          CompanyName: null,
          Name: null,
          Url: null,
          FileName: null,
          Identity: null,
          SimpleNational: false,
          StatusProvider: null,
          Situation: 1,
          ValidatePLD: false,
          CreatedDate: new Date(),
          HasContract: false,
          HasConfidentialityAgreement: false,
          ProviderDocumentFile: null,
          ContractStartDate: null,
          ContractEndDate: null,
          validatedModuleForm: false,
          validatedActionForm: false,
          FileProviderInternal: [],
          IdUserInternal: null,
          ProviderFile: {
            File: []
          },
          PaymentMethodProviderInternal: {
            PaymentProviderInternalType: { Id: null },
            PaymentProviderInternalBank: {
              Name: null,
              Account: null,
              Agency: null,
              DigitAccount: null,
              DigitAgency: null,
              IdAccountType: null
            },
            PaymentProviderInternalPix: {
              KeyName: null,
              Key: null
            }
          },
          ProviderType: {
            Id: 0,
            Description: null
          },
          Contact: {
            Name: null,
            Phone: null,
            Email: null,
            Branch: null
          },
          Address: {
            Street: null,
            District: null,
            Number: null,
            ZipCode: null,
            Complement: null,
            City: {
              Name: null,
              CityCodeIBGE: 0,
            },
            State: {
              Initials: null,
            },
            Country: {
              Name: null,
            },
          },
        };
    },
    ListCountry: function () {
      this.$store
        .dispatch("ListCountry")
        .then((response) => {
          this.countries = response;
          this.countriesFilter = response;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro carregar a lista de países",
            error
          );
        });
    },
    ListState: function (nameCountry) {
      if (nameCountry != null) {
        let CountryItem = this.countries.find((elem) => {
          return elem.Name.toUpperCase() == nameCountry;
        });

        if (CountryItem.Id != undefined) {
          this.$store
            .dispatch("ListState", { idCountry: CountryItem.Id })
            .then((response) => {
              this.states = response;
            });
        }
      }
    },
    ListStateFilter: function (nameCountry) {
      if (nameCountry != null) {
        let CountryItem = this.countriesFilter.find((elem) => {
          return elem.Name.toUpperCase() == nameCountry;
        });

        if (CountryItem.Id != undefined) {
          this.$store
            .dispatch("ListState", { idCountry: CountryItem.Id })
            .then((response) => {
              this.statesFilter = response;
            });
        }
      }
    },
    onChange: function (e) {
      this.infoProviderInternal.PaymentMethodProviderInternal.PaymentProviderInternalType.Name = null
    },

    NextStep() {
      this.validatedFormValidation = true;
      this.$refs.formValidation.validate().then((valid) => {
        if (valid && this.mCurrentStep < this.mSteps.length - 1) {
          this.validatedFormValidation = false;
          this.mCurrentStep += 1;
        }
      });
    },
    BackStep() {
      if (this.mCurrentStep >= 1) {
        this.validatedFormValidation = false;
        this.mCurrentStep -= 1;
      }
    },
    GoToStep(e, stepToGo) {
      e.preventDefault();
      if (stepToGo < 0 || stepToGo >= this.mSteps.length) return;
      if (stepToGo > this.mCurrentStep) {
        this.validatedFormValidation = true;
        this.$refs.formValidation.validate().then((valid) => {
          if (valid) {
            this.validatedFormValidation = false;
            this.mCurrentStep = stepToGo;
          }
        });
      } else {
        this.validatedFormValidation = false;
        this.mCurrentStep = stepToGo;
      }
    },
    SaveProvider: function () {
      this.validatedFormValidation = true;
      let validate = this.Validateattachment();
      let validateIdentity = this.ValidateIdentityMessage();
      this.$refs.formValidation.validate().then((valid) => {
        if (valid && validate && validateIdentity) {
          this.SaveProviderInternal();
        }
      });
    },

    Validateattachment: function () {

      if (this.infoProviderInternal.HasContract == true && this.infoProviderInternal.HasConfidentialityAgreement == false && this.infoProviderInternal.FileProviderInternal.length == 0) {
        this.$makeToast(
          "Anexe o arquivo do Contrato",
          "warning",
          "Anexo",
        );
        return false;
      }

      if (this.infoProviderInternal.HasContract == false && this.infoProviderInternal.HasConfidentialityAgreement == true && this.infoProviderInternal.FileProviderInternal.length == 0) {
        this.$makeToast(
          "Anexe o arquivo do Acordo de Confidencialidade (NDA)",
          "warning",
          "Anexo",
        );
        return false;
      }

      if (this.infoProviderInternal.HasContract == true && this.infoProviderInternal.HasConfidentialityAgreement == true && this.infoProviderInternal.FileProviderInternal.length < 2) {
        this.$makeToast(
          "Anexe o arquivo do Contrato e o arquivo do Acordo de Confidencialidade (NDA)",
          "warning",
          "Anexo",
        );
        return false;
      }

      return true;
    },

    ConfirmDeleteProviderInternal: function (e, i) {
      e.preventDefault();
      this.$makeMsgBox(
        `Você tem certeza que deseja remover esse fornecedor?`,
        "Confirmar EXCLUSÃO",
        this.RemoveProvider,
        i
      );
    },
    ConfirmDeleteFileProviderInternal: function (e, id, name, url) {
      e.preventDefault();
      this.$makeMsgBox(
        `Você tem certeza que deseja remover o anexo ${name}?`,
        "Confirmar EXCLUSÃO",
        this.DeleteFileProviderInternal,
        id, name, url
      );
    },
    SaveProviderInternal() {
      this.loadingModal = true;
      let isTicket = 0;
      if (this.IsAccountsPayable) {
        isTicket = this.infoProviderInternal.PaymentMethodProviderInternal.PaymentProviderInternalType.Id
      }
      if (this.isCreating) {
        // Add
        let providerDoc = this.infoProviderInternal;
        providerDoc = JSON.parse(JSON.stringify(providerDoc));
        var formData = this.GetFormData(providerDoc);

        for (var i = 0; i != this.providerFiles.length; i++) {
          formData.append("Files", this.providerFiles[i]);
        }

        this.$store
          .dispatch("AddProviderInternal", formData)
          .then((response) => {
            if (response.Id == 0) {
              this.$makeToast(
                "O fornecedor já está cadastrado na base de dados",
                "warning",
                "Fornecedor já existe",
              );
            } else {
              this.$makeToast(
                "O fornecedor foi cadastrado corretamente na base de dados.",
                "success",
                "Fornecedor cadastrado"
              );
              this.ListProvider();
              if (this.IsAccountsPayable) {
                this.$router.push({
                  name: "accountspayable",
                  query: {
                    identity: response.Identity
                    // IsReturnProviderAdd: true,
                    // IdProvider: response.Id,
                    // IsAccountsPayable: this.IsAccountsPayable,
                    // isTicket: isTicket
                  },
                });
              }
              this.FeedbackProvider();
              this.ResetInfoProvider();
            }

          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao criar o fornecedor",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
      else {
        // Update
        let providerDoc = this.infoProviderInternal;
        providerDoc = JSON.parse(JSON.stringify(providerDoc));
        var formData = this.GetFormData(providerDoc);

        for (var i = 0; i != this.providerFiles.length; i++) {
          formData.append("Files", this.providerFiles[i]);
        }

        this.$store
          .dispatch("UpdateProviderInternal", formData)
          .then(() => {
            this.$makeToast(
              "Suas modificações foram salvas na base de dados.",
              "success",
              "Fornecedor atualizado"
            );
            this.ResetInfoProvider();
            this.ListProvider();
            if (this.IsAccountsPayable)
              localStorage.setItem('idProvider', this.infoProviderInternal.id);
            this.FeedbackProvider();
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao atualizar o fornecedor",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }

    },
    saveProviderLocalStorage() {
      const identity = JSON.stringify(this.infoProviderInternal.Identity);
      localStorage.setItem('identity', 'identity');
    },
    FeedbackProvider() {
      this.ListProvider();
      this.$bvModal.hide("mFormProvider");
    },

    onChangePaymentKeyPix(e) {
      this.infoProviderInternal.PaymentMethodProviderInternal.PaymentProviderInternalPix.Key = "";
    },
    ListUserInternalRoot: function () {
      let data = {
        ...{
          PageNumber: 0,
          RowsPerPage: 0,
        },
      };
      this.$store
        .dispatch("ListUserInternal", { params: data })
        .then((response) => {
          this.usersRoot = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "warning",
            "Erro ao listar os coordenadores",
            error
          );
        });
    },

    ValidateIdentityMessage: function () {

      if (this.infoProviderInternal.PaymentMethodProviderInternal.PaymentProviderInternalType.Id == 1) {

        if (this.infoProviderInternal.PaymentMethodProviderInternal.PaymentProviderInternalPix.KeyName == "CPF") {
          let valid = this.ValidateIdentity(this.infoProviderInternal.PaymentMethodProviderInternal.PaymentProviderInternalPix.Key)

          if (!valid) {
            this.$makeToast(
              "A chave CPF do PIX não é valida",
              "warning",
              "CPF do PIX",
            );
            return false;
          }
        }
        if (this.infoProviderInternal.PaymentMethodProviderInternal.PaymentProviderInternalPix.KeyName == "CNPJ") {
          let valid = this.ValidateIdentity(this.infoProviderInternal.PaymentMethodProviderInternal.PaymentProviderInternalPix.Key)

          if (!valid) {
            this.$makeToast(
              "A chave CNPJ do PIX não é valida",
              "warning",
              "CNPJ do PIX",
            );
            return false;
          }
        }
        if (this.infoProviderInternal.PaymentMethodProviderInternal.PaymentProviderInternalPix.KeyName == "Email") {
          let valid = this.ValidacoaEmail(this.infoProviderInternal.PaymentMethodProviderInternal.PaymentProviderInternalPix.Key)

          if (!valid) {
            this.$makeToast(
              "A chave e-mail do PIX não é válida",
              "warning",
              "Email do PIX",
            );
            return false;
          }
        }


        //|| this.infoProviderInternal.PaymentMethodProviderInternal.PaymentProviderInternalPix.KeyName == "CNPJ")

      }

      if (!this.ValidateIdentity(this.infoProviderInternal.Identity)) {
        this.$makeToast(
          "O CPF ou o CNPJ do Fornecedor não é valido",
          "warning",
          "CNPJ/CPF",
        );
        return false;
      }


      return true;
    },

    ValidacoaEmail: function (email) {
      if (/\S+@\S+\.\S+/.test(email)) {
        return true;
      }
      return false;
    },

    ValidateIdentity: function (val) {
      {
        if (val.length == 11) {
          var cpf = val.trim();

          cpf = cpf.replace(/\./g, '');
          cpf = cpf.replace('-', '');
          cpf = cpf.split('');

          var v1 = 0;
          var v2 = 0;
          var aux = false;

          for (var i = 1; cpf.length > i; i++) {
            if (cpf[i - 1] != cpf[i]) {
              aux = true;
            }
          }

          if (aux == false) {
            return false;
          }

          for (var i = 0, p = 10; (cpf.length - 2) > i; i++, p--) {
            v1 += cpf[i] * p;
          }

          v1 = ((v1 * 10) % 11);

          if (v1 == 10) {
            v1 = 0;
          }

          if (v1 != cpf[9]) {
            return false;
          }

          for (var i = 0, p = 11; (cpf.length - 1) > i; i++, p--) {
            v2 += cpf[i] * p;
          }

          v2 = ((v2 * 10) % 11);

          if (v2 == 10) {
            v2 = 0;
          }

          if (v2 != cpf[10]) {
            return false;
          } else {
            return true;
          }
        } else if (val.length == 14) {
          var cnpj = val.trim();

          cnpj = cnpj.replace(/\./g, '');
          cnpj = cnpj.replace('-', '');
          cnpj = cnpj.replace('/', '');
          cnpj = cnpj.split('');

          var v1 = 0;
          var v2 = 0;
          var aux = false;

          for (var i = 1; cnpj.length > i; i++) {
            if (cnpj[i - 1] != cnpj[i]) {
              aux = true;
            }
          }

          if (aux == false) {
            return false;
          }

          for (var i = 0, p1 = 5, p2 = 13; (cnpj.length - 2) > i; i++, p1--, p2--) {
            if (p1 >= 2) {
              v1 += cnpj[i] * p1;
            } else {
              v1 += cnpj[i] * p2;
            }
          }

          v1 = (v1 % 11);

          if (v1 < 2) {
            v1 = 0;
          } else {
            v1 = (11 - v1);
          }

          if (v1 != cnpj[12]) {
            return false;
          }

          for (var i = 0, p1 = 6, p2 = 14; (cnpj.length - 1) > i; i++, p1--, p2--) {
            if (p1 >= 2) {
              v2 += cnpj[i] * p1;
            } else {
              v2 += cnpj[i] * p2;
            }
          }

          v2 = (v2 % 11);

          if (v2 < 2) {
            v2 = 0;
          } else {
            v2 = (11 - v2);
          }

          if (v2 != cnpj[13]) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      }
    },

    ListProvider: function () {
      this.loadingList = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      if (hasValue(this.filter.ContractStartDate)) this.countFilter++;
      if (hasValue(this.filter.ContractEndDate)) this.countFilter++;
      if (hasValue(this.filter.ContractStartDateFrom)) this.countFilter++;
      if (hasValue(this.filter.ContractEndDateFrom)) this.countFilter++;
      if (hasValue(this.filter.IdUserInternal)) this.countFilter++;
      if (hasValue(this.filter.StatusProvider)) this.countFilter++;
      if (hasValue(this.filter.Situation)) this.countFilter++;
      if (hasValue(this.filter.Address && this.filter.Address.City && this.filter.Address.City.Name)) this.countFilter++;
      if (hasValue(this.filter.Address && this.filter.Address.State && this.filter.Address.State.Initials)) this.countFilter++;
      if (hasValue(this.filter.Address && this.filter.Address.Country && this.filter.Address.Country.Name)) this.countFilter++;
      if (hasValue(this.filter.PaymentMethodProviderInternal && this.filter.PaymentMethodProviderInternal.PaymentProviderInternalType && this.filter.PaymentMethodProviderInternal.PaymentProviderInternalType.Id)) this.countFilter++;
      if (hasValue(this.filter.ProviderType.Id)) this.countFilter++;
      if (hasValue(this.filter.Contact.Name)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Name": this.filter.Name,
          "Object.Identity": this.filter.Identity,
          "Object.ContractStartDate": this.filter.ContractStartDate,
          "Object.ContractEndDate": this.filter.ContractEndDate,
          "Object.ContractStartDateFrom": this.filter.ContractStartDateFrom,
          "Object.ContractEndDateFrom": this.filter.ContractEndDateFrom,
          "Object.IdUserInternal": this.filter.IdUserInternal,
          "Object.StatusProvider": this.filter.StatusProvider,
          "Object.Situation": this.filter.Situation,
          "Object.Address.City.Name": this.filter.Address.City.Name,
          "Object.Address.State.Initials": this.filter.Address.State.Initials,
          "Object.Address.Country.Name": this.filter.Address.Country.Name,
          "Object.PaymentMethodProviderInternal.PaymentProviderInternalType.Id": this.filter.PaymentMethodProviderInternal.PaymentProviderInternalType.Id,
          "Object.IdProviderInternalType": this.filter.ProviderType.Id,
          "Object.Contact.Name": this.filter.Contact.Name
        }
      }
      this.$store
        .dispatch("ListProviderInternal", { params: data })
        .then((response) => {
          this.providers = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente atualizar a página",
            "danger",
            "Erro ao obter lista de perfis",
            error
          );
        })
        .finally(() => {
          this.loadingList = false;
        });
    },

    CancelAccounts: function () {
      this.$router.push({
        name: "accountspayable",
        query: {
          isCancelProvider: true,
        },
      });
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/pages/Financial/Provider/Provider.js